module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/disclaimer.json
// module id = 690
// module chunks = 183279941031601